import { Pipe, PipeTransform } from '@angular/core';
import { DiscoverTeaser } from '@zero/discover/domain';

@Pipe({
  name: 'discoverSlide',
  standalone: true,
})
export class DiscoverSlidePipe implements PipeTransform {
  public transform = (value: DiscoverTeaser[], ...args: number[]): DiscoverTeaser[] => this.#getItems(value, args[0], args[1]);

  #getItems(items: DiscoverTeaser[], currentSlide: number, itemsPerSlide: number): DiscoverTeaser[] {
    const startIndex = (currentSlide - 1) * itemsPerSlide;
    return items.slice(startIndex, startIndex + itemsPerSlide);
  }
}
